module.exports = __webpack_public_path__ + "static/img/郭振宇董事长1.95d0c499.png";